/**
 * Dynamic-import map for Module Federation remotes.
 *
 * Why this exists: Module Federation's vite plugin needs **literal** module
 * specifiers (e.g. `import("integrations/App")`) to rewrite into remote loads.
 * A fully data-driven `import(config.url)` would not be transformed. So each
 * registered MFE needs ONE line here matching its `scope` + `exposedModule`.
 *
 * Keys must match `MfeDefinition.name` in `registry.js`. Works identically
 * for `source: "local"` and `source: "remote"` MFEs — only the dev URL in
 * `registry.js` differs; the import specifier is the same shape.
 */
export const remoteLoaders = {
  integrations: () => import("integrations/App"),
  agent: () => import("agent/App"),
  "ispm-ui": () => import("ispm_ui/App"),
  "universal-onboarding": () => import("universal_onboarding/App"),
};

export function loadRemote(name) {
  const loader = remoteLoaders[name];
  if (!loader) {
    return Promise.reject(new Error(`No remote loader registered for "${name}"`));
  }
  return loader();
}
